<template>
  <div id="add-customer-owners">
    <add-user-form
      :add-user-drawer="isDrawerOpen"
      @close-nav-drawer="toogleDrawer"
      email-address-label="OWNER information"
      @user-added="onSubmitHandler"
    />
    <loader :loading="isLoading" :size="$appConfig.loader.small" />
  </div>
</template>

<script>
import { required } from "@/validators";
import AddUserForm from "../forms/AddUserForm.vue";
import { isResponseCode } from "@/utils/common.utils";

import { addCustomerOwner } from "@/services";
import { RESPONSE_CODES, ROLES } from "@/constants";
import SharedUtilsMixin from "@/mixins/SharedUtils.mixin";

/**
 * Add customer owner drawer form
 */
export default {
  name: "AddCustomerOwnerDrawer",
  /**
  |--------------------------------------------------
  | Mixins
  |--------------------------------------------------
  */
  mixins: [SharedUtilsMixin],
  /**
   * ---------------- Custom events ------------------
   */
  emits: ["toogle-drawer", "update-records"],
  /**
   * ---------------- Props ------------------
   */
  props: {
    isDrawerOpen: { type: Boolean, required: true, default: false },
  },
  /**
   * ---------------- Components ------------------
   */
  components: { AddUserForm },
  /**
   * ---------------- Data Properties ------------------
   */
  data() {
    return {
      isLoading: false,
    };
  },
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    required,
    /**
     * Toogles drawer
     * @param {Boolean} val Updated value of the isDrawerOpen prop
     * @emits toogle-drawer
     */
    toogleDrawer(val) {
      this.$emit("toogle-drawer", val);
    },
    /**
     * Add customer access to user request payload
     * @type {Object}
     */
    payload({ id: owner_id }) {
      return { owners: { owner_id, role: ROLES.owner } };
    },
    /**
     * Form submit handler
     */
    async onSubmitHandler(data) {
      try {
        if (!data) return;
        this.isLoading = true;

        const { id } = this.$route.params;
        const { status } = await addCustomerOwner(id, this.payload(data));

        if (isResponseCode(status, RESPONSE_CODES.success)) {
          this.setSnackbar({
            value: true,
            message: this.$dictionary.app.customers.owner.addAccess.successMsg,
            type: this.snackbarTypes.success,
          });
        }

        this.toogleDrawer(false);
        this.$emit("update-records");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
